/**
 * Default: Utils > Manifest
 *
 * @copyright 2025 i-fabrik GmbH
 * @author Tobias Garz
 */

import {
	isElement,
	isNode,
	isObject
} from '../../shared/utils/is';
import SelectorEngine from '../../shared/dom/selector-engine';

// -------
// Private
// -------

// -------
// Public
// -------

/**
 * get JSON of inline scripts
 *
 * @param element
 * @param {string} selector
 * @returns {json}
 */
const getInlineConfig = (selector = '', element) => {
	if(!element) {
		return;
	}

	const configEl = selector ? SelectorEngine.findOne(`[data-config="${selector}"]`, element) : element;
	let config     = {};

	if (configEl) {
		config = JSON.parse(configEl.innerHTML);

		configEl.remove();
	}

	return config;
};

// -------
// Export
// -------

export {
	getInlineConfig
};